<!--
 * @Author: your name
 * @Date: 2021-12-23 11:15:34
 * @LastEditTime: 2022-03-08 17:25:28
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\components\explorer\NewMediaList\MediaList.vue
-->
<template>
  <ul class="media-list">
    <li class="is-selected flex-c-c">
      <el-checkbox v-model="fileChecked" @change="checkboxChange"></el-checkbox>
    </li>
    <li class="name attr flex-c" @dblclick="$emit('openMedia')">
      <img class="m-img" :src="media.ref_thumb_url" alt />
      <span class="ellipsis-1">{{media.name}}</span>
    </li>
    <li class="attr flex-c">
      <span style="padding-left: 16px;">{{media.ref_wh}}</span>
    </li>
    <li class="attr flex-c">{{formatType(media)}}</li>
    <li class="attr flex-c">{{media.create_time}}</li>
    <li class="attr flex-a-c">
      <img class="icon" src="@imgpub/move.png" @click="handleMedia('move')" :title="$t('explorer.move')" />
      <img class="icon" src="@imgpub/public_copy.png" @click="handleMedia('copy')" :title="$t('explorer.copy')" />
      <img class="icon" src="@imgpub/public_delete.png" @click="handleMedia('del')" :title="$t('explorer.delete')" />
    </li>
  </ul>
</template>

<script>
export default {
  name: "MediaList",
  props: {
    media: {
      type: Object,
      default: () => { }
    },
    isSelected: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      mediaChecked: false,
    }
  },
  methods: {
    timeFormatting(time) {
      let ms = parseInt(time);
      let H = Math.floor(ms / 1000 / 60 / 60);
      let M = Math.floor(ms / 1000 / 60) % 60;
      let S = Math.ceil(ms / 1000) % 60;
      return `${this.formatting(H)}:${this.formatting(M)}:${this.formatting(S)}`;
    },
    handleMedia(type) {
      switch (type) {
        case "move":
          this.$emit("setMediaMoveId", this.media.id, "move");
          break;
        case "share":
          break;
        case "copy":
          this.$emit("setMediaMoveId", this.media.id, "copy");
          break;
        case "del":
          this.$emit("setDeleteMedia", this.media.id);
          break;

        default:
          break;
      }
    },
    checkboxChange(val) {
      this.$emit("setSelectMedia", val, this.media.id);
    },
    formatType(row) {
      let refSize = (row.ref_size / 1024).toFixed(1);
      let refSizeMB = refSize / 1024;
      if (refSizeMB < 1) {
        refSize = (refSizeMB * 1024).toFixed(1) + "KB";
      } else if (refSizeMB >= 1 && refSizeMB < 1024) {
        refSize = refSizeMB.toFixed(1) + "MB";
      } else if (refSizeMB >= 1024) {
        refSize = (refSizeMB / 1024).toFixed(1) + "GB";
      }
      switch (row.type.toString()) {
        case "1": return `视频(${refSize})`;
        case "2": return `图片(${refSize})`;
        case "6": return `mp3(${refSize})`;
        case "10": return `文本(${refSize})`;
        default: return `未定义类型(${refSize})`;
      }
    },
  },
  watch: {
    isSelected: {
      handler(nVal) {
        this.mediaChecked = nVal;
      }
    }
  },

}
</script>

<style lang="scss" scoped>
.media-list {
  display: flex;
  justify-content: space-between;
  height: 56px;
  padding: 12px 0;
  border-top: 1px solid #ebeef5;
  .is-selected {
    width: 50px;
  }
  .attr {
    width: calc(20% - 10px);
    user-select: none;
    .m-img {
      width: 100px;
      height: 56px;
      user-select: none;
      cursor: pointer;
    }
    span {
      padding-left: 8px;
    }
    .icon {
      width: 30px;
      height: 30px;
    }
  }
  .attr:nth-child(2) {
    width: calc(20%);
  }
  .attr:last-child {
    width: calc(20% - 20px);
  }
}
</style>